import routeError from './route.error';
import routeAuth from './route.auth';
import routeService from './route.service';

import routePermission from './route.permission';
import routeUserInfo from './route.user_info';
import routeGroupInfo from './route.group';
import routeNotice from './route.notice';
import routeUsageInfo from './route.usage';
import routeContact from './route.contact';
import routeGuide from './route.guide';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/home/Home'),
    meta: {
      layout: 'HomeLayout',
    },
  },
  ...routeError,
  ...routeAuth,
  ...routeService,
  ...routePermission,
  ...routeUserInfo,
  ...routeGroupInfo,
  ...routeNotice,
  ...routeUsageInfo,
  ...routeContact,
  ...routeGuide,
  {
    path: '*',
    redirect: '/',
  },
];

export default routes;
